import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import CONFIG from 'common/config.json';
const shogiUtil = require('common/shogiUtil');
import BoardStateDto from 'common/boardStateDto';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        layout:[],
        capturedPlayer1KomaList:[],
        capturedPlayer2KomaList:[],
        playerSide:'',
        round:0,
        selectedCell:null,
        moveableList:[],
        boardLock:false,
        allPromotableFlag:false
      },
      mutations: {
        mutateBoardState(state,newBoardState) {
          state.layout=newBoardState.layout;
          state.capturedPlayer1KomaList=newBoardState.capturedPlayer1KomaList;
          state.capturedPlayer2KomaList=newBoardState.capturedPlayer2KomaList;
          state.playerSide=newBoardState.playerSide;
        },
        mutatecapturedPlayer1KomaList(state,newCapturedPlayer1KomaList) {
          state.capturedPlayer1KomaList=newCapturedPlayer1KomaList;
        },
        mutateCapturedPlayer2KomaList(state,newCapturedPlayer2KomaList) {
          state.capturedPlayer2KomaList=newCapturedPlayer2KomaList;
        },
        mutateSelectedCell(state,cellDomain=null){
          state.selectedCell=cellDomain;
        },
        mutateMoveableList(state,newMoveableList=[]){
          state.moveableList=newMoveableList;
        },
        mutateBoardLock(state,lock){
          state.boardLock=lock;
        },
        resetRoundCount(state){
          state.round=1;
        },
        roundIncrement(state){
          state.round++;
        },
        mutateAllPromotableFlag(state,flag=false){
          state.allPromotableFlag=flag;
        }
      },
      actions: {
        // プレヤーが更新したstateObjをsubimtし、思考エンジンAPIから次の手を求める。
        submitMove ({commit},boardStateDto) {
          commit('mutateBoardState',boardStateDto);
          commit('roundIncrement');
          commit('mutateSelectedCell');  
          commit('mutateMoveableList');
          commit('mutateAllPromotableFlag')
          commit('mutateBoardLock',true);
        },
        retriveComMove({commit,getters}){
          const startTime=new Date().getTime();
          submitBoardStateAndRetrive(getters.boardState).then(response=>{
            let delayTime=CONFIG.comPlayIntervalMin-(new Date().getTime()-startTime);
            delayTime=delayTime>0? delayTime:0;
            setTimeout(()=>{
              commit('mutateBoardState',shogiUtil.revertBoardViewSide(response.data));
              commit('mutateBoardLock',false);
            },delayTime);
          });
        },
        setSelectedCell({commit},cellDomain){
          commit('mutateSelectedCell',cellDomain);
        },
        setMoveableList({commit},list){
          commit('mutateMoveableList',list);
        },
        setAllMovePromotable({commit},flag){
          commit('mutateAllPromotableFlag',flag);
        },
        setupGame({commit},playerSide){
            commit('mutateBoardState',new BoardStateDto(
              shogiUtil.deepCopy(CONFIG.defaultLayout),
              [],[],playerSide));
            commit('resetRoundCount');
        }
      },
      getters:{
        flatLayout: state=>{
          return shogiUtil.flattenLayout(state.layout);
        },
        boardState: state=>{
          return new BoardStateDto(state.layout,state.capturedPlayer2KomaList,state.capturedPlayer1KomaList,state.playerSide);
        }
      }
  })
  // APIと直接通信
  function submitBoardStateAndRetrive(boardStateDto){
    let config = {
      headers: {
        // Aliyun use appcode for authorization
        Authorization:'APPCODE '+CONFIG.appCode
      }
    }
    return new Promise(resolve=>{
      axios
      .post(CONFIG.server.concat(CONFIG.api),JSON.stringify(boardStateDto),config)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        alert(error)
      })
    }) 
  }